import React, { useState } from 'react';
import Select from 'react-select';
import { FormGroup } from 'react-bootstrap';
import { customStyles } from '../../../../Components/helper';

export function DropDown({
  placeHolder,
  label,
  name,
  requiredField,
  fromForm,
  duplicatingItem,
  index,
  i,
  id,
  eleIndex,
  elekey,
  disable,
  editingInput,
  showDelete,
  deleteItem,
  value,
  onChange,
  options,
  elementId,
  fromCustomSection,
}) {
  const [isOver, setIsOver] = useState(false);

  const mouseOver = () => {
    setIsOver(true);
  };
  const mouseOut = () => {
    setIsOver(false);
  };

  const handleDuplicateItem = () => {
    fromCustomSection ? duplicatingItem(index, i, elementId, fromCustomSection) : duplicatingItem(index, i, elekey);
    setIsOver(false);
  };

  return (
    <FormGroup className="flex-fill position-relative">
      <div className="custom-react-select-po" onMouseEnter={mouseOver} onMouseLeave={mouseOut}>
        <label className={`mb-1 field-lbl asterisk-req ${fromForm && 'd-flex'}`}>
          {label}
          {requiredField && <span>*</span>}
        </label>
        {fromForm && isOver && (
          <div className="potemp-action-btns">
            <button
              type="button"
              className="btn btn-border ml-auto  py-0 px-1"
              key={`_${eleIndex}_${i}_${index}_edit`}
              onClick={() => editingInput(index, i, eleIndex)}
            >
              <span className="icon-edit" />
            </button>
            {showDelete && isOver && (
              <button
                type="button"
                className="btn btn-border  py-0 px-1"
                key={`_${eleIndex}_${i}_${index}_delete`}
                onClick={() => deleteItem(index, i, elekey, eleIndex)}
              >
                <span className="icon-delete" />
              </button>
            )}
            <button type="button" className="btn btn-border  py-0 px-1" key={`_${eleIndex}_${i}_${index}_duplicate`} onClick={() => handleDuplicateItem()}>
              <span className="icon-copy" />
            </button>
          </div>
        )}
        <Select
          key={`_${eleIndex}_${i}_${index}`}
          name={name}
          options={options}
          getOptionLabel={(option) => `${option?.name}`}
          getOptionValue={(option) => `${option?.name}`}
          isDisabled={disable}
          inputProps={{
            autoComplete: 'off',
            autoCorrect: 'off',
            spellCheck: 'off',
          }}
          styles={customStyles}
          placeholder={placeHolder}
          value={value}
          onChange={(e) => onChange(e, label, i, eleIndex, index)}
        />
      </div>
    </FormGroup>
  );
}
export default DropDown;
